StepManager = {
    loadedEvent: 'fm.step.loaded',
    base: '/web',
    controller: '/site',
    init: function () {
        this.events();
        this.autoLoad();
    },
    events: function () {

        var $body = $('body');

        $body.on('click', '[data-step="process"]', function (ev) {

            ev.preventDefault();

            var $el = $(this),
                $form = $el.closest('form');

            $.post($form.attr('action'), $form.serialize(), function (data) {

            });
        });

        $body.on('click', '.btn-next, .btn-back', function (ev) {

            $this = $(this);
            const step = $this.data('step')
            var val = false;
            const current = step - 1;

            //We must validate this action
            if ($this.hasClass('btn-back') || !$this.data('validate')) {
                val = true;
            } else if ($this.hasClass('btn-next')) {

                if ($(`#slide-${current} [name="locations"]`).length > 0 &&
                    $('[name="locations"]').data('value').length > 0) {
                    val = true;
                } else {
                    $(`#slide-${current} input[type=checkbox], #slide-${current} input[type=radio]`).each(function () {
                        if (this.checked) {
                            val = true;
                        }
                    });
                }
            }

            if (val == true) {
                window.scrollTo(0, 0);
                $this.closest('.step-container').addClass('hidden')
                $(`#slide-${step} > .step-container`).removeClass('hidden')
            } else {
                $('.card-footer .slide-actions').append('<span id="error-msg" style="display:inline-block; margin-top:10px;" class="text-center text-danger">Please select at least one of the above options.</span>');
            }

        })


        $(document).on('click', '.btn-submit', function (e) {
            let el = $(this);
            let form = $('#step-form');
            let validPhone = false;
            let phone = $("#floatingPhone").val();

            $.ajax({
                type: "post",
                url: '/web/site/validate-phone',
                data: {
                    phone: phone
                },
                success: function (response) {
                    response = jQuery.parseJSON(response);
                    if (form[0].checkValidity() && response.valid) {
                        el.prop('disabled', true);
                        $('[name="locations"]').val($('[name="locations"]').data('value'));
                        $.ajax({
                            type: "POST",
                            url: "/web/site/find-your-franchise",
                            data: {
                                data: $('#step-form').serialize()
                            },
                            success: function (data) {
                                var json = jQuery.parseJSON(data);
                                if (json.success) {
                                    $.ajax({
                                        type: "POST",
                                        url: "/web/api/send-submission/" + json.submission_id,
                                        success: function (response) {
                                            response = jQuery.parseJSON(response);
                                            console.log(response);
                                            var url = "https://" + response.CoachPurl + ".esourcecoach.com/education/?utm_source=FM_CoachRedirect_040122";
                                            setTimeout(window.open(url, "_blank"), 5000);
                                            window.location = "/web/site/confirmation/" + json.submission_id;
                                        }
                                    });
                                }
                            }
                        });
                    } else {
                        event.preventDefault();
                        event.stopPropagation();
                        // form.addClass('was-validated');
                        if(!response.valid){
                            $('#floatingPhone').addClass('is-invalid');
                        }
                        return false;
                    }
                }
            });
        });
        $(document).on('click', '.slide-choices input', function () {
            $('.card-footer #error-msg').remove();
        });
        $(document).on('click', '.selected-location', function () {
            const autocomplete = $('[name="locations"]')
            const list = autocomplete.data('value')
            const value = this.childNodes[1].value;
            const replace = list.replace(new RegExp(value + ',?'), '')
            autocomplete.data('value', replace)
            this.parentNode.removeChild(this);

            if (autocomplete.data('value').length === 0) {
                document.getElementById('selected-locations').childNodes[1].classList.remove('hidden')
            }
        });

        $(document).on("keyup paste", '#floatingPhone', function() {
            // Remove invalid chars from the input
            var input = this.value.replace(/[^0-9\(\)\s\-]/g, "");
            var inputlen = input.length;
            // Get just the numbers in the input
            var numbers = this.value.replace(/\D/g,'');
            var numberslen = numbers.length;
            // Value to store the masked input
            var newval = "";

            // Loop through the existing numbers and apply the mask
            for(var i=0;i<numberslen;i++){
                if(i==0) newval="("+numbers[i];
                else if(i==3) newval+=") "+numbers[i];
                else if(i==6) newval+="-"+numbers[i];
                else newval+=numbers[i];
            }

            // Re-add the non-digit characters to the end of the input that the user entered and that match the mask.
            if(inputlen>=1&&numberslen==0&&input[0]=="(") newval="(";
            else if(inputlen>=6&&numberslen==3&&input[4]==")"&&input[5]==" ") newval+=") ";
            else if(inputlen>=5&&numberslen==3&&input[4]==")") newval+=")";
            else if(inputlen>=6&&numberslen==3&&input[5]==" ") newval+=" ";
            else if(inputlen>=10&&numberslen==6&&input[9]=="-") newval+="-";

            $(this).val(newval.substring(0,14));
        });
    },
    verifyPhone: function(phone) {
        $.ajax({
            type: "post",
            url: `${this.base}${this.controller}/validate-phone`,
            data: { phone:phone },
            success: function (response) {
                return response;
            }
        });
    },
    autoLoad: function () {
        if (!window.steploaded) {
            var $step = $('[data-load-step]');
            if ($step.length)
                this.load($step.data('loadStep'), $step);
        }
    },

    load: function (step_number, $step) {
        $.ajax({
            type: "get",
            url: `${this.base}${this.controller}/find-your-franchise`,
            success: function (response) {
                $step.append($(response));
                $.get('/web/step/location-ajax', function (data) {
                    autocomplete($('[name="locations"]')[0], JSON.parse(data));
                });
            }
        });
    }
}

function autocomplete(inp, arr) {
    /*the autocomplete function takes two arguments,
    the text field element and an array of possible autocompleted values:*/
    var currentFocus;
    /*execute a function when someone writes in the text field:*/
    inp.addEventListener("input", function (e) {
        var a, b, c, d, i, found = 0, val = this.value;
        /*close any already open lists of autocompleted values*/
        closeAllLists();
        if (!val) { return false; }
        currentFocus = -1;
        /*create a DIV element that will contain the items (values):*/
        a = document.createElement("DIV");
        d = document.getElementById('selected-locations')
        //a.setAttribute("id", this.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        /*append the DIV element as a child of the autocomplete container:*/
        // this.parentNode.appendChild(a);
        //this.insertAfter(a)
        this.parentNode.insertBefore(a, this.nextSibling);
        /* filter out used id's */
        const fArr = arr.filter(n => !$(inp).data('value').split(", ").includes(n.id))
        /*for each item in the array...*/
        let isValue;
        for (i = 0; i < fArr.length; i++) {
            isValue = false
            /*check if the item starts with the same letters as the text field value:*/
            isValue = fArr[i].value.substr(0, val.length).toUpperCase() == val.toUpperCase()
            if (isValue
                || fArr[i].state.substr(0, val.length).toUpperCase() == val.toUpperCase()
                || fArr[i].abbr.substr(0, val.length).toUpperCase() == val.toUpperCase()) {
                found++;
                /*create a DIV element for each matching element:*/
                b = document.createElement("DIV");
                /*make the matching letters bold:*/
                if (isValue) {
                    b.innerHTML = "<div class='location-text'><strong>" + fArr[i].value.substr(0, val.length) + "</strong>" + fArr[i].value.substr(val.length); +"</div>";
                } else { // isState
                    b.innerHTML = "<div class='location-text'>" + fArr[i].value.replace(fArr[i].abbr, '') + "<strong>" + fArr[i].abbr; +"</strong></div>";
                }

                /*insert a input field that will hold the current fArray item's value:*/
                b.innerHTML += "<input data-id='" + fArr[i].id + "' type='hidden' value='" + fArr[i].value + "'>";
                /*execute a function when someone clicks on the item value (DIV element):*/
                b.addEventListener("click", function (e) {
                    /*insert the value for the autocomplete text field:*/
                    inp.value = ''
                    if ($(inp).data('value').length === 0) {
                        d.childNodes[1].classList.add('hidden')
                    }
                    const inpValue = $(inp).data('value')
                    const dataId = this.getElementsByTagName("input")[0].getAttribute('data-id');
                    $(inp).data('value', inpValue + (inpValue.length > 0 ? ',' : '') + dataId);
                    c = document.createElement("DIV");
                    c.classList.add('selected-location')
                    c.innerHTML = this.getElementsByTagName("input")[0].value;
                    c.innerHTML += "<input type='hidden' value='" + dataId + "'>";
                    d.appendChild(c);
                    /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
                    closeAllLists();
                });
                if (found < 6) {
                    a.appendChild(b)
                }
            }
            if (!found && (i + 1) === fArr.length) {
                a.innerHTML = "no results"
            }
        }
    });
    /*execute a function presses a key on the keyboard:*/
    inp.addEventListener("keydown", function (e) {
        var x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(x);
        } else if (e.keyCode == 38) { //up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(x);
        } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
                /*and simulate a click on the "active" item:*/
                if (x) x[currentFocus].click();
            }
        }
    });
    function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = (x.length - 1);
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    }
    function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != inp) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {
        closeAllLists(e.target);
    });
}
